import React from 'react';
import App from 'App';
import paths, { rootPaths } from './paths';
import { Navigate, createBrowserRouter } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import ErrorLayout from '../layouts/ErrorLayout';
import Error404 from 'components/errors/Error404';
import Error500 from 'components/errors/Error500';

import {Add as Addcontact} from "../components/pages/contact/Add";
import {Edit as Editcontact} from "../components/pages/contact/Edit";
import {List  as Listcontact} from "../components/pages/contact/Lista";

import {Add as Addregistration} from "../components/pages/registration/Add";
import {Edit as Editregistration} from "../components/pages/registration/Edit";
import {List  as Listregistration} from "../components/pages/registration/Lista";
import {Items  as Itemsregistration} from "../components/pages/registration/Items";

import {Add as Addmembership} from "../components/pages/membership/Add";
import {Edit as Editmembership} from "../components/pages/membership/Edit";
import {List  as Listmembership} from "../components/pages/membership/Lista";

import {Add as Addcontract} from "../components/pages/contract/Add";
import {Edit as Editcontract} from "../components/pages/contract/Edit";
import {List  as Listcontract} from "../components/pages/contract/Lista";

import {Add as Addtermination} from "../components/pages/termination/Add";
import {Edit as Edittermination} from "../components/pages/termination/Edit";
import {List  as Listtermination} from "../components/pages/termination/Lista";

import {Add as Addcoach} from "../components/pages/coach/Add";
import {Edit as Editcoach} from "../components/pages/coach/Edit";
import {List  as Listcoach} from "../components/pages/coach/Lista";

import {Add as Addstaff} from "../components/pages/staff/Add";
import {Edit as Editstaff} from "../components/pages/staff/Edit";
import {List  as Liststaff} from "../components/pages/staff/Lista";

import {Add as Addsupervisor} from "../components/pages/supervisor/Add";
import {Edit as Editsupervisor} from "../components/pages/supervisor/Edit";
import {List  as Listsupervisor} from "../components/pages/supervisor/Lista";
import {List as ListSportsHalls} from '../components/pages/sports-hall/Lista';

import {Add as Addjudge} from "../components/pages/judge/Add";
import {Edit as Editjudge} from "../components/pages/judge/Edit";
import {List  as Listjudge} from "../components/pages/judge/Lista";

import {Add as Addclub} from "../components/pages/club/Add";
import {Edit as Editclub} from "../components/pages/club/Edit";
import {List  as Listclub} from "../components/pages/club/Lista";

import {Add as Addplayer} from "../components/pages/player/Add";
import {Edit as Editplayer} from "../components/pages/player/Edit";
import {List  as Listplayer} from "../components/pages/player/Lista";
import {List as Listarchive} from "../components/pages/archive/Lista";

import {Add as Adduser} from "../components/pages/user/Add";
import {Edit as Edituser} from "../components/pages/user/Edit";
import {List  as Listuser} from "../components/pages/user/Lista";
import {Confirm  as Confirmuser} from "../components/pages/user/Confirm";

import {Add as Addcompetition} from "../components/pages/competition/Add";
import {Edit as Editcompetition} from "../components/pages/competition/Edit";
import {List  as Listcompetition} from "../components/pages/competition/Lista";
import {List  as ListClubs} from "../components/pages/competition/Clubs";

import {List as Playerslicense} from "../components/pages/license/Players";
import {List  as Listlicense} from "../components/pages/license/Lista";
import RoundSchedule from "../components/pages/matches/round-schedule";
import MatchSchedule from "../components/pages/matches/match-schedule";
import PlayedMatches from "../components/pages/matches/played-matches";
import ActiveMatches from "../components/pages/matches/active-matches";
import MatchReport from "../components/pages/matches/report";

import DatePicker from 'components/doc-components/DatePicker';

import AuthSimpleLayout from '../layouts/AuthSimpleLayout';
import SimpleLogin from 'components/authentication/simple/Login';
import SimplePasswordReset from 'components/authentication/simple/PasswordReset';
import SimpleForgetPassword from 'components/authentication/simple/ForgetPassword';
import SimpleConfirmMail from 'components/authentication/simple/ConfirmMail';

import Starter from 'components/pages/migration/index';

import {ContactHome} from "../components/pages/home/Contact";

const HomeRoute = () => {
  const storedUser = localStorage.getItem('user');
  const user = storedUser ? JSON.parse(storedUser) : null;
  const restrictedRoles = ['staff', 'judge', 'supervisor'];

  if (restrictedRoles.includes(user?.role_type_id)) {
    return <Navigate to={paths.activeMatches} replace />;
  }

  return <Listplayer />;
};

const routes = [
  {
    element: <App />,
    children: [
      {
        path: rootPaths.errorsRoot,
        element: <ErrorLayout />,
        children: [
          {
            path: paths.error404,
            element: <Error404 />
          },
          {
            path: paths.error500,
            element: <Error500 />
          }
        ]
      },
      {
        path: rootPaths.authRoot,
        children: [
          {
            path: rootPaths.authSimpleRoot,
            element: <AuthSimpleLayout />,
            children: [
              {
                path: paths.simpleLogin,
                element: <SimpleLogin />
              },
              {
                path: paths.simpleForgotPassword,
                element: <SimpleForgetPassword />
              },
              {
                path: paths.simpleResetPassword,
                element: <SimplePasswordReset />
              },
              {
                path: paths.simpleConfirmMail,
                element: <SimpleConfirmMail />
              },
            ]
          }
        ]
      },
      {
        path: '/',
        element: <MainLayout />,
        children: [
          {
            index: true,
            element: <HomeRoute />,
          },
          {
            path: rootPaths.clubs,
            children: [
              {
                index: true,
                element: <Listclub />,
              },
              {
                path: 'edit',
                children: [
                  {
                    path: ':clubId',
                    element: <Editclub />,
                  },
                ],
              },
              {
                path: 'add',
                element: <Addclub />,
              },
            ]
          },
          {
            path: rootPaths.contactClub,
            children: [
              {
                index: true,
                path: ':club_guid',
                element: <ContactHome />,
              }
            ]
          },
          {
            path: rootPaths.coachs,
            children: [
              {
                index: true,
                element: <Listcoach />,
              },
              {
                path: 'edit',
                children: [
                  {
                    path: ':coachsId',
                    element: <Editcoach />,
                  },
                ],
              },
              {
                path: 'add',
                element: <Addcoach />,
              },
            ]
          },

          {
            path: rootPaths.staff,
            children: [
              {
                index: true,
                element: <Liststaff />,
              },
              {
                path: 'edit',
                children: [
                  {
                    path: ':staffId',
                    element: <Editstaff />,
                  },
                ],
              },
              {
                path: 'add',
                element: <Addstaff />,
              },
            ]
          },

          {
            path: rootPaths.competitions,
            children: [
              {
                index: true,
                element: <Listcompetition />,
              },
              {
                path: 'edit',
                children: [
                  {
                    path: ':competitionsId',
                    element: <Editcompetition />,
                  },
                ],
              },
              {
                path: 'add',
                element: <Addcompetition />,
              },
              {
                path: 'clubs',
                children: [
                  {
                    path: ':competitionsClubId',
                    element: <ListClubs />,
                  },
                ],
              },
            ]
          },
          {
            path: rootPaths.license,
            children: [
              {
                index: true,
                element: <Listlicense />,
              },
              {
                path: 'players',
                children: [
                  {
                    path: ':licenseId',
                    element: <Playerslicense />,
                  },
                ],
              }
            ]
          },
          {
            path: rootPaths.roundSchedule,
            children: [
              {
                index: true,
                element: <RoundSchedule />
              }
            ]
          },
          {
            path: rootPaths.matchSchedule,
            children: [
              {
                index: true,
                element: <MatchSchedule />
              }
            ]
          },
          {
            path: rootPaths.playedMatches,
            children: [
              {
                index: true,
                element: <PlayedMatches />
              }
            ]
          },
          {
            path: rootPaths.activeMatches,
            children: [
              {
                index: true,
                element: <ActiveMatches />
              },
              {
                path: 'report/:matchesGuid',
                element: <MatchReport />
              }
            ]
          },
          {
            path: rootPaths.contact,
            children: [
              {
                index: true,
                path: ':entities_guide',
                element: <Listcontact />,
              },
              {
                path: 'edit',
                children: [
                  {
                    path: ':contactId',
                    element: <Editcontact />,
                  },
                ],
              },
              {
                path: 'add',
                element: <Addcontact />,
              },
            ]
          },
          {
            path: rootPaths.registration,
            children: [
              {
                index: true,
                //path: ':entities_guide',
                element: <Listregistration />,
              },
              {
                path: 'edit',
                children: [
                  {
                    path: ':document_guid',
                    element: <Editregistration />,
                  },
                ],
              },
              {
                path: 'add',
                element: <Addregistration />,
              },
              {
                path: 'items',
                children: [
                  {
                    path: ':registration_guid',
                    element: <Itemsregistration />,
                  },
                ],
              },
            ]
          },
          {
            path: rootPaths.membership,
            children: [
              {
                index: true,
                //path: ':entities_guide',
                element: <Listmembership />,
              },
              {
                path: 'edit',
                children: [
                  {
                    path: ':document_guid',
                    element: <Editmembership />,
                  },
                ],
              },
              {
                path: 'add',
                element: <Addmembership />,
              },
            ]
          },
          {
            path: rootPaths.termination,
            children: [
              {
                index: true,
                //path: ':entities_guide',
                element: <Listtermination />,
              },
              {
                path: 'edit',
                children: [
                  {
                    path: ':document_guid',
                    element: <Edittermination />,
                  },
                ],
              },
              {
                path: 'add',
                element: <Addtermination />,
              },
            ]
          },
          {
            path: rootPaths.contract,
            children: [
              {
                index: true,
                element: <Listcontract />,
              },
              {
                path: 'edit',
                children: [
                  {
                    path: ':document_guid',
                    element: <Editcontract />,
                  },
                ],
              },
              {
                path: 'add',
                element: <Addcontract />,
              },
            ]
          },
          {
            path: rootPaths.supervisors,
            children: [
              {
                index: true,
                element: <Listsupervisor />,
              },
              {
                path: 'edit',
                children: [
                  {
                    path: ':supervisorsId',
                    element: <Editsupervisor />,
                  },
                ],
              },
              {
                path: 'add',
                element: <Addsupervisor />,
              },
            ]
          },
          {
            path: rootPaths.sportsHalls,
            children: [
              {
                index: true,
                element: <ListSportsHalls />
              }
            ]
          },
          {
            path: rootPaths.players,
            children: [
              {
                index: true,
                element: <Listplayer />,
              },
              {
                path: 'edit',
                children: [
                  {
                    path: ':playerId',
                    element: <Editplayer />,
                  },
                ],
              },
              {
                path: 'add',
                element: <Addplayer />,
              },
            ]
          },
          {
            path: rootPaths.archive,
            children: [
              {
                index: true,
                element: <Listarchive />
              }
            ]
          },
          {
            path: rootPaths.users,
            children: [
              {
                index: true,
                element: <Listuser />,
              },
              {
                path: 'edit',
                children: [
                  {
                    path: ':usersId',
                    element: <Edituser />,
                  },
                ],
              },
              {
                path: 'add',
                element: <Adduser />,
              },
              {
                path: 'confirm',
                element: <Confirmuser />,
              },
            ]
          },
          {
            path: rootPaths.migration,
            children: [
              {
                index: true,
                element: <Starter />,
              },
            ]
          },
          {
            path: rootPaths.judges,
            children: [
              {
                index: true,
                element: <Listjudge/>,
              },
              {
                path: 'edit',
                children: [
                  {
                    path: ':judgeId',
                    element: <Editjudge />,
                  },
                ],
              },
              {
                path: 'add',
                element: <Addjudge />,
              },
            ]
          },
        ]
      },
      {
        path: '*',
        element: <Navigate to={paths.error404} replace />
      }
    ]
  }
];

export const router = createBrowserRouter(routes, {
  basename: process.env.PUBLIC_URL
});

export default routes;
